import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { AccountService } from 'app/core';
import { environment } from '@env/environment';
import { AccountIntegrationSlug } from 'app/shared/enums';
import { UserService } from 'app/layout/common/user/user.service';
import {
  User,
  Account,
  ProjectType,
  PropertyType,
  ProjectStage,
  InvestmentType,
  Team,
  Vehicle,
  MarketStatus,
  AccountIntegration,
  Integration,
} from 'app/core/models';
import { EgnyteSubDomainModalComponent } from '../egnyte/egnyte-subdomain-modal/egnyte-subdomain-modal.component';

@Component({
  selector: 'integrations-list',
  templateUrl: './integrations-list.component.html',
})
export class IntegrationsListComponent extends OnDestroyMixin implements OnInit {
  public dropdowns: any;
  public investmentTypes: InvestmentType[];
  public marketStatuses: MarketStatus[];
  public projectTypes: ProjectType[];
  public propertyTypes: PropertyType[];
  public projectStages: ProjectStage[];
  public teams: Team[];
  public vehicles: Vehicle[];
  public accountIntegrations$: Observable<AccountIntegration[]>;
  public accountIntegrationsError$: Observable<HttpErrorResponse>;
  public account: Account;
  public currentUser: User;

  constructor(
    private readonly _userService: UserService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly _accountService: AccountService,
    private readonly _matDialog: MatDialog,
  ) {
    super();

    this._accountService.currentAccount.pipe(untilComponentDestroyed(this)).subscribe((accountData) => {
      this.account = accountData;
    });

    this._userService.user$.pipe(untilComponentDestroyed(this)).subscribe((user: User) => {
      if (user) {
        this.currentUser = user;
      }
      this._changeDetectorRef.markForCheck();
    });
  }

  ngOnInit(): void {
    this.loadIntegrations();
    this.accountIntegrationsError$ = this._accountService.accountIntegrationsError$;
  }

  private loadIntegrations(): void {
    this.accountIntegrations$ = this._accountService.getAccountIntegrations().pipe(
      untilComponentDestroyed(this),
      map((apps) => apps.filter((app) => app.integration.slug.includes(AccountIntegrationSlug.Connect) === false)),
    );
  }

  public connectIntegration(accountIntegration: AccountIntegration): void {
    const { integration, integration_id } = accountIntegration;
    if (integration.name.includes('Egnyte')) {
      this.triggerEgnyteSubDomainModal(integration);
    } else {
      window.open(
        // eslint-disable-next-line max-len
        `${environment.baseUrl}/integrations/${integration.slug}/setup?integration_id=${integration_id}&user_id=${this.currentUser.id}`,
      );
    }
  }

  private triggerEgnyteSubDomainModal(integration: Integration): MatDialogRef<EgnyteSubDomainModalComponent> {
    return this._matDialog.open(EgnyteSubDomainModalComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: { account: this.account, integration, user: this.currentUser },
    });
  }
}
